import React from 'react'
import Loadable from 'react-loadable'
import {Spin} from 'antd'

//通用的过场组件
const loadingComponent =()=>{
    return (
        <Spin className="Loading" tip="Loading..." />
    ) 
}

// 路由懒加载(异步组件)
export default (loader,loading=loadingComponent)=>{
    return Loadable({
        loader,
        loading
    }) 
}